import { authClient, API } from "../../utils/index";

export const getPlantillas = () => {
	return authClient().get(`${API}/plantilla`);
};
